// extracted by mini-css-extract-plugin
export default {"container":"Print_container__G42O4"};